<div class="description-container">
  <div class="description-content">
    <p class="current-description">{{ currentDescription }}</p>
  </div>
  @if (hasAudioResults) {
    <button
        (click)="onRefreshClick()"
        [disabled]="isLoadingAlternatives"
        aria-label="Try alternative prompt"
        class="refresh-btn"
    >
      @if (!isLoadingAlternatives) {
        <svg fill="none" height="20" viewBox="0 0 24 24" width="20">
          <path
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
      } @else {
        <svg class="animate-spin" fill="none" height="20" viewBox="0 0 24 24" width="20">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"></path>
        </svg>
      }
    </button>
  }
</div>
